import type { ProLayoutProps } from '@ant-design/pro-components';

/**
 * @name
 */
const Settings: ProLayoutProps & {
  pwa?: boolean;
  logo?: string;
} = 
// {
//   navTheme: 'light',
//   // 拂晓蓝
//   colorPrimary: '#1890ff',
//   layout: 'mix',
//   contentWidth: 'Fluid',
//   fixedHeader: false,
//   fixSiderbar: true,
//   colorWeak: false,
  //   title: 'Ghostore Admin',
//   pwa: true,
//   logo: 'https://gw.alipayobjects.com/zos/rmsportal/KDpgvguMpGfqaHPjicRK.svg',
//   iconfontUrl: '',
//   token: {
//     // 参见ts声明，demo 见文档，通过token 修改样式
//     //https://procomponents.ant.design/components/layout#%E9%80%9A%E8%BF%87-token-%E4%BF%AE%E6%94%B9%E6%A0%B7%E5%BC%8F
//   },

  
// };

{
  // "navTheme": "light",
  "layout": "mix",
  "contentWidth": "Fluid",
  "fixedHeader": true,
  "fixSiderbar": true,
  "title": 'GhostoreAdmin',
  "pwa": true,
  "logo": '/logo.png',
  // "token": {
  // },
  // 一级菜单放顶部横向导航，当前一级下的二级菜单留在左侧
  "splitMenus": true,
  "siderMenuType": "sub"
}


export default Settings;
